// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import storage from './utils/storage'
Vue.prototype.$storage = storage

import Vuex from 'vuex'
Vue.use(Vuex)

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

//跳转之前
router.beforeEach((to,from,next) => {
  if(!storage.get('openid') || !storage.get('unionid')){
    //缓存没有openid去登录 登录页面除外
    if(to.name=='login' || to.name=='oAuth'){
      next()
    }else {
      next('/login')
    }
  }else {
    next()
  }
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js